"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeRect = void 0;
var utils_1 = require("../../utils");
var bbox_1 = require("../types/record/bbox");
var shrink_to_fit_in_img_1 = require("./shrink-to-fit-in-img");
/**
 *
 * @param rectBefore リサイズ前のRect
 * @param vector 動かした量
 * @param direction 掴んでいる点のbboxにおける位置
 *
 *  [ nw ]---[ n ]---[ ne ]
 *    |                 |
 *    |                 |
 *  [ w ]             [ e ]
 *    |                 |
 *    |                 |
 *  [ sw ]---[ s ]---[ se ]
 *
 */
var resizeRectByPoint = function (rectBefore, vector, direction) {
    switch (direction) {
        case 'e':
            return rectBefore.update('width', function (w) { return w + vector.x; });
        case 's':
            return rectBefore.update('height', function (w) { return w + vector.y; });
        case 'w':
            return rectBefore.withMutations(function (rect) {
                rect
                    .update('width', function (w) { return w - vector.x; })
                    .update('left', function (l) { return l + vector.x; });
            });
        case 'n':
            return rectBefore.withMutations(function (rect) {
                rect
                    .update('height', function (h) { return h - vector.y; })
                    .update('top', function (t) { return t + vector.y; });
            });
        case 'se':
            return rectBefore.withMutations(function (rect) {
                rect
                    .update('width', function (w) { return w + vector.x; })
                    .update('height', function (w) { return w + vector.y; });
            });
        case 'sw':
            return rectBefore.withMutations(function (rect) {
                rect
                    .update('height', function (w) { return w + vector.y; })
                    .update('width', function (w) { return w - vector.x; })
                    .update('left', function (l) { return l + vector.x; });
            });
        case 'ne':
            return rectBefore.withMutations(function (rect) {
                rect
                    .update('height', function (h) { return h - vector.y; })
                    .update('top', function (t) { return t + vector.y; })
                    .update('width', function (w) { return w + vector.x; });
            });
        case 'nw':
            return rectBefore.withMutations(function (rect) {
                rect
                    .update('height', function (h) { return h - vector.y; })
                    .update('top', function (t) { return t + vector.y; })
                    .update('width', function (w) { return w - vector.x; })
                    .update('left', function (l) { return l + vector.x; });
            });
        default:
            return (0, utils_1.IRect)();
    }
};
var moveRect = function (rectBefore, vector) {
    return rectBefore.withMutations(function (rect) {
        // clampで画像範囲内に収まるようにする
        return rect
            .update('top', function (t) { return (0, utils_1.clamp)(0, 1 - rect.height)(t + vector.y); })
            .update('left', function (l) { return (0, utils_1.clamp)(0, 1 - rect.width)(l + vector.x); });
    });
};
/**
 * @description ドラッグ情報と掴んでいる部位を基にリサイズ or 移動後のRectを返す
 * @param dragVector 移動量
 * @param selectedElement 現在リサイズ or 移動しようとしているbboxの掴んでいる部位
 */
var resizeRect = function (dragVector, selectedElement) {
    var type = selectedElement.type, location = selectedElement.location, parent = selectedElement.parent;
    switch (type) {
        case 'point':
            return (0, bbox_1.IBbox)({
                id: parent.id,
                label: parent.label,
                rect: (0, shrink_to_fit_in_img_1.shrinkToFitInImgRelative)((0, utils_1.normalizeRect)(resizeRectByPoint(parent.rect, dragVector, location)))
            });
        case 'edge':
            return (0, bbox_1.IBbox)({
                id: parent.id,
                label: parent.label,
                rect: (0, shrink_to_fit_in_img_1.shrinkToFitInImgRelative)(moveRect(parent.rect, dragVector))
            });
    }
};
exports.resizeRect = resizeRect;
